// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a2e511ad","239":"f0844b1f","272":"9377a0f6","455":"63d4a6c1","483":"bd1c52a2","536":"23feb6fb","836":"34ecf61a","941":"8faa0798"}[chunkId] + ".chunk.js";
};